import React, { useEffect, useState } from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useQueryFilter from '../../useQueryFilter'
import tarefaSlaRepository from '../../TarefaSlaRepository'
import { formatGerenciadora } from '../../../../utils/Formatter'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing()
  }
}))

const CardsQuantidade = props => {
  const classes = useStyles()
  const [quantidades, setQuantidades] = useState([])
  const [query] = useQueryFilter(props.location.search)

  useEffect(() => {
    async function fetchData() {
      const response = await tarefaSlaRepository.viagensAtualCount({
        gerenciadora: query.gerenciadora
      })
      if (response.ok) {
        setQuantidades(response.data)
      }
    }
    fetchData()
    const interval = setInterval(fetchData, 1000 * 30)
    return () => clearInterval(interval)
  }, [query])

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.card}>
          <Grid container spacing={2}>
            {quantidades.map((quantidade, index) => (
              <Grid item xs={12} sm={3} key={index}>
                <Typography gutterBottom>
                  Quantidade {formatGerenciadora(quantidade.gerenciadora)}
                </Typography>
                <Typography variant="h5">{quantidade.quantidade}</Typography>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grid>
    </>
  )
}

export default React.memo(CardsQuantidade)
